const TEAM_LABELS = {
  "individu male": "Individu Putra",
  "individu female": "Individu Putri",
  individu_mix: "Individu",
  male_team: "Beregu Putra",
  female_team: "Beregu Putri",
  mix_team: "Beregu Campuran",
};

const TEAM_IDS_IN_FIXED_ORDER = [
  "individu male",
  "individu female",
  "individu_mix",
  "male_team",
  "female_team",
  "mix_team",
];

export default { TEAM_LABELS, TEAM_IDS_IN_FIXED_ORDER };
